import api from './api';

export interface AnoLetivo {
  id: number;
  ano: number;
  ativo: boolean;
  aceitaMatriculas: boolean;
  aceitaRematriculas: boolean;
  criadoEm: string;
  atualizadoEm: string;
}

export interface CreateAnoLetivoDto {
  ano: number;
  ativo?: boolean;
  aceitaMatriculas?: boolean;
  aceitaRematriculas?: boolean;
}

export interface UpdateAnoLetivoDto {
  ano?: number;
  ativo?: boolean;
  aceitaMatriculas?: boolean;
  aceitaRematriculas?: boolean;
}

class AnoLetivoService {
  private baseUrl = '/anos-letivos';

  async listarAnosLetivos(): Promise<AnoLetivo[]> {
    try {
      const response = await api.get(this.baseUrl);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao listar anos letivos');
    }
  }

  async buscarAnoLetivo(id: number): Promise<AnoLetivo> {
    try {
      const response = await api.get(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar ano letivo');
    }
  }

  async criarAnoLetivo(data: CreateAnoLetivoDto): Promise<AnoLetivo> {
    try {
      const response = await api.post(this.baseUrl, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao criar ano letivo');
    }
  }

  async atualizarAnoLetivo(id: number, data: UpdateAnoLetivoDto): Promise<AnoLetivo> {
    try {
      const response = await api.patch(`${this.baseUrl}/${id}`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar ano letivo');
    }
  }

  async excluirAnoLetivo(id: number): Promise<void> {
    try {
      await api.delete(`${this.baseUrl}/${id}`);
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir ano letivo');
    }
  }

  async toggleAtivo(id: number): Promise<AnoLetivo> {
    try {
      const response = await api.patch(`${this.baseUrl}/${id}/toggle-ativo`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao alterar status ativo');
    }
  }

  async toggleMatriculas(id: number): Promise<AnoLetivo> {
    try {
      const response = await api.patch(`${this.baseUrl}/${id}/toggle-matriculas`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao alterar aceitação de matrículas');
    }
  }

  async toggleRematriculas(id: number): Promise<AnoLetivo> {
    try {
      const response = await api.patch(`${this.baseUrl}/${id}/toggle-rematriculas`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erro ao alterar aceitação de rematrículas');
    }
  }

  async validarAno(ano: number, id?: number): Promise<boolean> {
    try {
      // Buscar todos os anos letivos e verificar se já existe
      const anosLetivos = await this.listarAnosLetivos();
      const anoExistente = anosLetivos.find(al => al.ano === ano && al.id !== id);
      return !anoExistente; // retorna true se não existe (é válido)
    } catch (error: any) {
      return true; // em caso de erro, permite a validação
    }
  }
}

export const anoLetivoService = new AnoLetivoService();
